const tagFromParentElement = (element: HTMLElement, tagName: string, className?: string): HTMLElement => {
  if (element.tagName === tagName) {
    if (!className) return element;
    if (element.classList.contains(className)) return element;
  }
  if (!element.parentElement) return;
  return tagFromParentElement(element.parentElement, tagName, className);
};

export const getTagFromEvent = (event: Event, tagName: string, className?: string): HTMLElement => {
  const target = event.target as HTMLElement;
  return tagFromParentElement(target, tagName, className);
};
